module.exports = __webpack_public_path__ + "static/media/03-02.c32f76cd.png";